import "../styles/Contact.css";
import { Col, Container, Row } from "react-bootstrap";
import contact1 from "../assets/contact1.png";
import contact2 from "../assets/contact2.png";
import contact3 from "../assets/contact3.png";
import contact4 from "../assets/contact4.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
   faInstagram,
   faFacebookF,
   faWhatsapp,
   faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import Swal from "sweetalert2";
import { useState } from "react";
import useInputField from "../hooks/useInputField";
import {
   useContactUsMsgMutation,
   useGetSettingsQuery,
} from "../redux/features/home/homeApiSlice";

function Contact() {
   // ################### CUSTOM HOOKS ###################
   const [contactUsMsg, focusedInput, handleContactUsMsg, clearData] =
      useInputField({
         full_name: "",
         phone_number: "",
         email: "",
         message: "",
      });

   // ################### RTK QUERY ###################
   const [sendContactUsmsg, { isLoading }] = useContactUsMsgMutation();
   const { data: settings, isSuccess } = useGetSettingsQuery();

   // ################### VALIDATION ###################
   const validateContactUsMsg = () => {
      const emailValidation = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      if (!Object.values(contactUsMsg).every((e) => e !== "")) {
         Swal.fire({
            icon: "error",
            text: "الرجاء ملىء جميع الحقول.",
         });
      } else if (!emailValidation.test(contactUsMsg.email)) {
         Swal.fire({
            icon: "error",
            text: "الرجاء إدخال عنوان بريد الكتروني صحيح.",
         });
      } else if (
         +contactUsMsg.phone_number <= 0 ||
         contactUsMsg.phone_number.length < 4
      ) {
         Swal.fire({
            icon: "error",
            text: "الرجاء إدخال رقم هاتف صحيح.",
         });
      } else {
         return true;
      }
   };

   // ################### HANDLER ###################
   const handleSendMsg = async (e) => {
      try {
         e.preventDefault();
         if (validateContactUsMsg()) {
            const data = new FormData();
            data.append("full_name", contactUsMsg.full_name);
            data.append("phone_number", contactUsMsg.phone_number);
            data.append("email", contactUsMsg.email);
            data.append("message", contactUsMsg.message);

            await sendContactUsmsg(data).unwrap();

            Swal.fire({
               text: "تم إرسال الرسالة بنجاح.",
               icon: "success",
            });

            clearData();
         }
      } catch (err) {
         // TODO: Add alert from sweetAlert2 to show it when get error
         console.log(err);
      }
   };

   // ################### CONTENT ###################
   let content;
   if (isSuccess) {
      const { data: info } = settings;
      content = (
         <Row className="align-items-center justify-content-center">
            <Col className="contact-us-number" md={5}>
               <div className="call-icon">
                  <img src={contact4} alt="" />
               </div>
               <div className="call-info">
                  <h6>تواصل معنا</h6>
                  <span>{info?.the_phone}</span>
               </div>
            </Col>
            <Col className="contact-social" md={6}>
               <ul>
                  <li>
                     <a href={info?.facebook}>
                        <FontAwesomeIcon icon={faFacebookF} />
                     </a>
                  </li>
                  <li>
                     <a href={`https://wa.me/963${info?.whatsapp}`}>
                        <FontAwesomeIcon icon={faWhatsapp} />
                     </a>
                  </li>
                  <li>
                     <a href={info?.instagram}>
                        <FontAwesomeIcon icon={faInstagram} />
                     </a>
                  </li>
                  <li>
                     <a href={info?.linkedin}>
                        <FontAwesomeIcon icon={faLinkedin} />
                     </a>
                  </li>
               </ul>
            </Col>
         </Row>
      );
   }

   //    const handleFaceBookQRCode = () => {
   //       Swal.fire({
   //          imageUrl: "imgs/flowcode2.png",

   //          html:
   //             '<h2 style="color: black ">Scan It</h3> </br>' +
   //             '<a href="https://www.facebook.com/matrixerpsyria" style="color: rgb(24 220 220)" target="_blank">..Or Click Here To Visit FaceBook Directly </a>',
   //          imageHeight: 250,
   //          imageAlt: "FaceBook Matrix QRCode",
   //          confirmButtonText: "Close",
   //          //   focusConfirm: false
   //          confirmButtonColor: "#031723",
   //       });
   //    };
   //    const handleWhatsAppQRCode = () => {
   //       Swal.fire({
   //          imageUrl: "imgs/flowcode.png",

   //          html:
   //             '<h2 style="color: black ">Scan It</h3> </br>' +
   //             '<a href="" style="color: rgb(24 220 220)" >..Or Click Here To Visit WhatsApp Directly </a>',
   //          imageHeight: 250,
   //          imageAlt: "FaceBook Matrix QRCode",
   //          confirmButtonText: "Close",

   //          confirmButtonColor: "#031723",
   //       });
   //    };
   //    const handleInstaQRCode = () => {
   //       Swal.fire({
   //          imageUrl: "imgs/flowcode.png",

   //          html:
   //             '<h2 style="color: black ">Scan It</h3> </br>' +
   //             '<a href="" style="color: rgb(24 220 220)">..Or Click Here To Visit Instagram Directly </a>',
   //          imageHeight: 250,
   //          imageAlt: "FaceBook Matrix QRCode",
   //          confirmButtonText: "Close",
   //          //   focusConfirm: false
   //          confirmButtonColor: "#031723",
   //       });
   //    };
   //    const handleLinkedInQRCode = () => {
   //       Swal.fire({
   //          imageUrl: "imgs/flowcode.png",

   //          html:
   //             '<h2 style="color: black ">Scan It</h3> </br>' +
   //             '<a href="" style="color: rgb(24 220 220)">..Or Click Here To Visit LinkedIn Directly </a>',
   //          imageHeight: 250,
   //          imageAlt: "FaceBook Matrix QRCode",
   //          confirmButtonText: "Close",
   //          //   focusConfirm: false
   //          confirmButtonColor: "#031723",
   //       });
   //    };

   return (
      <div className="contact-comp" id="contact-comp">
         <Container>
            <Row className=" justify-content-between">
               <Col md={4}>
                  <div className="contact-form">
                     <p>تواصل معنا ليصلك كل جديد</p>
                     <form onSubmit={handleSendMsg}>
                        <input
                           type="text"
                           name="full_name"
                           placeholder="الاسم"
                           ref={focusedInput}
                           value={contactUsMsg.full_name}
                           onChange={handleContactUsMsg}
                        />
                        <input
                           type="email"
                           name="email"
                           placeholder="الايميل"
                           value={contactUsMsg.email}
                           onChange={handleContactUsMsg}
                        />
                        <input
                           type="number"
                           name="phone_number"
                           placeholder="رقم الهاتف"
                           value={contactUsMsg.phone_number}
                           onChange={handleContactUsMsg}
                        />
                        <textarea
                           placeholder="الرسالة"
                           name="message"
                           rows={4}
                           value={contactUsMsg.message}
                           onChange={handleContactUsMsg}
                        ></textarea>
                        <br />
                        {isLoading ? (
                           <input
                              type="submit"
                              disabled
                              value="جاري الإرسال ..."
                           />
                        ) : (
                           <input type="submit" value="ارسال" />
                        )}
                     </form>
                  </div>
               </Col>

               <Col md={7}>
                  <Row className="mb-4">
                     <Col className="nest-col1" md={6} xs={12}>
                        <div className="nest-col-div1">
                           <img src={contact1} alt="" />
                           <div>
                              <h5>+50</h5>
                              <span>المشاريع المنفذة</span>
                           </div>
                        </div>
                     </Col>
                     <Col className="nest-col2" md={6} xs={12}>
                        <div className="nest-col-div2">
                           <img src={contact2} alt="" />
                           <div>
                              <h5>+75</h5>
                              <span>عملاء</span>
                           </div>
                        </div>
                     </Col>
                  </Row>
                  <Row className="mb-4">
                     <img alt="" src={contact3} />
                  </Row>
                  {content}
               </Col>
            </Row>
         </Container>
      </div>
   );
}

export default Contact;
